import { useRef, useEffect } from "react";
import * as echarts from "echarts";
import { useRequest, useSize } from "ahooks";
import { statistic as statisticService } from "@/services";

function DepartmentChart({ token }) {
  const chartRef = useRef();
  const chartNodeRef = useRef();
  const size = useSize(chartNodeRef);
  const { loading } = useRequest(
    () => statisticService.listMessageDepartment(),
    {
      ready: !!token,
      onSuccess: (res) => {
        if (chartRef && chartRef.current) {
          chartRef.current.setOption({
            title: {
              text: "按上报单位",
              left: "center",
            },
            tooltip: {
              trigger: "item",
            },
            legend: {
              orient: "vertical",
              left: "left",
            },
            series: [
              {
                name: "数量",
                type: "pie",
                radius: "50%",
                data: res,
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          });
        }
      },
    }
  );
  useEffect(() => {
    const chartDom = chartNodeRef.current;
    if (!chartRef.current) {
      const c = echarts.init(chartDom);
      chartRef.current = c;
    }
    return () => {
      if (chartRef.current) chartRef.current.dispose();
    };
  }, [chartRef, chartNodeRef]);
  useEffect(() => {
    if (chartRef && !chartRef.current.isDisposed()) {
      chartRef.current.resize();
    }
  }, [chartRef, size]);
  return <div className="chart-wrapper" ref={chartNodeRef}></div>;
}

export default DepartmentChart;
